<style>
.picker-wrapper {
    overflow: hidden;
}
@-webkit-keyframes picker-close {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
    to {
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
    }
}
@keyframes picker-close {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
    to {
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
    }
}
@-webkit-keyframes picker-open {
    0% {
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
    }
    to {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}
@keyframes picker-open {
    0% {
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
    }
    to {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}
@-webkit-keyframes picker-close-backdrop {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
@keyframes picker-close-backdrop {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
@-webkit-keyframes picker-open-backdrop {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    to {
        opacity: 1;
    }
}
@keyframes picker-open-backdrop {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    to {
        opacity: 1;
    }
}
.picker-enter-active {
    -webkit-animation: picker-open-backdrop 0.3s ease-out;
    animation: picker-open-backdrop 0.3s ease-out;
}
.picker-enter-active .picker-wrapper {
    -webkit-animation: picker-open 0.3s ease;
    animation: picker-open 0.3s ease;
}
.picker-leave-active {
    -webkit-animation: picker-close-backdrop 0.3s ease-out;
    animation: picker-close-backdrop 0.3s ease-out;
}
.picker-leave-active .picker-wrapper {
    -webkit-animation: picker-close 0.3s ease;
    animation: picker-close 0.3s ease;
}
.picker-enter,
.picker-leave-active {
    opacity: 0;
}
.picker-bottom-content,
.picker-top-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
    width: 100%;
    background-color: #fff;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.picker-backdrop {
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
}
.picker-backdrop,
.picker-wrapper {
    left: 0;
    position: absolute;
    width: 100%;
}
.picker-wrapper {
    bottom: 0;
    background: transparent;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 9999;
}
.picker-content {
    position: relative;
    width: 100%;
    height: 228px;
    background: #fff;
}
.picker-body {
    z-index: 1;
    position: absolute;
    width: 100%;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-direction: row;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-justify-content: center;
}
.picker-body,
.picker-item {
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
}
.picker-item {
    font-size: 20px;
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-flex: 1;
}
.picker-helper {
    position: absolute;
    height: 100%;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.picker-helper,
.picker-helper:before {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
}
.picker-helper:before {
    content: "";
    height: 38px;
    border-top: 1px solid #adb0a7;
    border-bottom: 1px solid #adb0a7;
}
.picker-item-content {
    height: 36px;
    top: 96px;
    transform-style: preserve-3d;
    -webkit-transform-origin: center center -113.64752726415074px;
    transform-origin: center center -113.64752726415074px;
}
.picker-item-content,
.picker-item-content div {
    width: 100%;
    left: 0;
    position: absolute;
    -webkit-transform-style: preserve-3d;
}
.picker-item-content div {
    top: 36px;
    -webkit-transform-origin: top;
    transform-origin: top;
    transform-style: preserve-3d;
    -webkit-transform: rotateX(-18deg);
    transform: rotateX(-18deg);
}
.picker-item-content > div {
    top: 0;
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
}
.picker-item-content span {
    width: 100%;
    height: 36px;
    text-align: center;
    display: block;
    line-height: 36px;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>

<template>
    <transition name="picker">
        <touch class="picker-backdrop"
               v-show="value"
               v-on:tap="onClose">
            <div class="picker-wrapper">
                <slot class="picker-top-content"
                      name="top-content"></slot>
                <div class="picker-content">
                    <div class="picker-body">
                        <picker-item @change="onChangeValue"
                                     v-for="(item, index) in dataItems"
                                     :itemIndex="index"
                                     :index="item.index"
                                     :all-values="item.values"
                                     :values="item.$value"
                                     :length="item.values.length - 1"
                                     :maxScrollValue="item.maxScrollValue"
                                     :keyName="item.key"
                                     :style="item.style"
                                     :key="index"></picker-item>
                    </div>
                    <div class="picker-helper"></div>
                </div>
                <slot class="picker-bottom-content"
                      name="bottom-content"></slot>
            </div>
        </touch>
    </transition>
</template>
<script>

// import 'raf.js';

import Vue from 'vue';

import VueTouch from 'vue-touch';

import pickerItem from './picker-item.vue';

Vue.use(VueTouch, { name: 'touch' });

Vue.directive('for-nested', {
    bind (el, binding) {
        let value = binding.value[0];
        let key = binding.value[1];
        let html = '';
        for (let i = 0; i < 20; i++) {
            let n = 19 - i;
            let item = null;
            if (typeof value[n] == 'object') {
                item = value[n] && typeof value[n][key] !== 'undefined' ? value[n][key] : '';
            } else {
                item = typeof value[n] !== 'undefined' ? value[n] : '';
            }
            html = `<div><span data-index="${n}">${item}</span>${html}</div>`;
        }
        el.innerHTML = html;
    },
    update (el, binding) {
        let value = binding.value[0];
        let key = binding.value[1];
        let spenEl = el.querySelectorAll('span');
        let length = spenEl.length;
        for (let i = 0; i < length; i++) {
            let item = null;
            if (typeof value[i] == 'object') {
                item = value[i] && typeof value[i][key] !== 'undefined' ? value[i][key] : '';
            } else {
                item = typeof value[i] !== 'undefined' ? value[i] : '';
            }
            spenEl[i].innerHTML = item;
        }
    }
});

export default {
    name: 'picker',
    components: {
        'picker-item': pickerItem
    },
    data () {
        return {
            result: [],//结果
            flex: {
                '-webkit-box-flex': 'initial',
                '-ms-flex': 'initial',
                'flex': 'initial'
            }
        }
    },
    props: {
        value: {
            type: Boolean
        },
        dataItems: {
            type: Array
        },
        callbackArg: {}
    },
    methods: {
        onClose (...arg) {
            let e = arg[0];
            if (e.target && e.target.classList.contains('picker-backdrop')) {
                this.$emit('input', false);
            }
        },
        onChangeValue (itemIndex, result, isSend) {
            // //console.log(111)
            if (isSend) {
                this.result[itemIndex] = result;
                this.$emit('change', ...this.result, this.callbackArg);
            } else {
                this.result[itemIndex] = result;
            }
        },
        init (n) {
            Vue.set(n, 'key', n.name);
            if (n.width) {
                let width = { 'width': n.width }
                Vue.set(n, 'style', [width, this.flex]);
            }
            if (!n.maxScrollValue) {
                Vue.set(n, 'maxScrollValue', n.values.length);
            }
            n.$value = n.values.slice(0, 15);
        }
    },
    watch: {
        dataItems (newDataItems) {
            newDataItems.forEach(this.init);
        },
        value (result) {
            if (!result) return;
            this.$emit('change', ...this.result, this.callbackArg);
        }
    },
    created () {
        this.dataItems.forEach(this.init);
    }
}
</script>
